<div class="modal-header">
    <h4 class="modal-title"> {{data.isReferenceDevice ? 'Referans' : 'Müşteri'}} Cihazı Güncelle</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body col-12">
    <form [formGroup]="deviceForm">
        <div class="row" *ngIf="!data.isReferenceDevice">
            <!-- Firma Seçimi -->
            <div class="col-xl-4 col-md-6 col-sm-12 col-12">
                <label for="companyId">Firma</label>
                <ng-select [items]="companies" bindLabel="companyName" bindValue="id"
                    formControlName="companyId"></ng-select>
                <div *ngIf="deviceForm.get('companyId')?.invalid && deviceForm.get('companyId')?.touched"
                    class="text-danger">
                    Firma zorunludur.
                </div>
            </div>

            <!-- Firma Yetkili Kişi -->
            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="companyPersonId">Firma Yetkili Kişi</label>
                <div class="form-group">
                    <ng-select [bindValue]="'id'" formControlName="companyPersonId">
                        <ng-option *ngFor="let user of companyPersons" [value]="user.id">{{user.name + ' ' +
                            user.lastName}}</ng-option>
                    </ng-select>
                    <div *ngIf="deviceForm.get('companyPersonId').invalid && deviceForm.get('companyPersonId').touched"
                        class="text-danger">
                        Cihaz Yetkili Kişisi Zorunludur.
                    </div>
                </div>
            </div>
        </div>

        <!-- Ürünler -->
        <div class="row">

            <div class="col-xl-6 col-md-6 col-sm-12 col-12">
                <label for="deviceName">Cihaz Adı</label>
                <input type="text" class="form-control" formControlName="deviceName" maxlength="200" />
            </div>
            <!-- Cihaz Türü -->
            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="kindId">Cihaz Türü</label>
                <ng-select [items]="kinds" bindLabel="typeName" bindValue="id" formControlName="kindId"></ng-select>
            </div>

            <!-- Marka & Model -->
            <div class="col-xl-3 col-md-5 col-sm-11 col-12">
                <label for="brandModelId">Marka & Model</label>
                <div class="form-group">
                    <ng-select [items]="brands" [searchFn]="searchFn" bindLabel="name" bindValue="id"
                        groupBy="brandName" formControlName="brandModelId">
                        <ng-template ng-optgroup-tmp let-item="item">
                            {{ item.brandName || 'Bilinmeyen Marka' }}
                        </ng-template>
                    </ng-select>
                    <div *ngIf="deviceForm.get('brandModelId')?.invalid && deviceForm.get('brandModelId')?.touched"
                        class="text-danger">
                        Model seçmek zorunludur.
                    </div>
                </div>
            </div>
        </div>

        <!-- Additional Information -->
        <div class="row">

            <!-- Referans ID -->
            <div class="col-xl-5 col-md-6 col-sm-12 col-12">
                <label for="referenceId">Referans</label>
                <ng-select [bindValue]="'id'" formControlName="referenceId">
                    <ng-option *ngFor="let reference of references" [value]="reference.id">
                        {{reference.min + reference.unitTypeName + '-' + reference.max +reference.unitTypeName
                        }}</ng-option>
                </ng-select>
            </div>

            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="seriNo">Seri No</label>
                <input type="text" class="form-control" formControlName="seriNo" maxlength="30" />
            </div>

            <!-- Çözünürlük -->
            <div class="col-xl-2 col-md-6 col-sm-12 col-12">
                <label for="resolution">Çözünürlük</label>
                <input type="text" class="form-control" formControlName="resolution" />
            </div>


            <!-- Periyot -->
            <div class="col-xl-2 col-md-6 col-sm-12 col-12">
                <label for="period">Periyot(Ay)</label>
                <input type="number" class="form-control" formControlName="period" />
            </div>

            <!-- Envanter No -->
            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="inventoryNumber">Envanter No</label>
                <input type="text" class="form-control" formControlName="inventoryNumber" />
            </div>

            <!-- Yer -->
            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="place">Yer</label>
                <input type="text" class="form-control" formControlName="place" />
            </div>

            <!-- Cihaz Durumu (Aktif/Pasif) -->
            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="isDeviceStatus">Cihaz Durumu</label>
                <select formControlName="isDeviceStatus" class="form-control" id="isDeviceStatus">
                    <option [value]="true">Aktif</option>
                    <option [value]="false">Pasif</option>
                </select>
            </div>

            <!-- Açıklama -->
            <div class="col-xl-12 col-md-12 col-sm-12 col-12 mt-2">
                <label for="basicTextarea">Açıklama</label>
                <fieldset class="form-group">
                    <textarea class="form-control" id="basicTextarea" rows="1" placeholder="Cihaz açıklaması"
                        formControlName="description"></textarea>
                </fieldset>
            </div>
        </div>
    </form>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">Hayır</button>
    <button type="button" class="btn btn-success" [disabled]="!deviceForm.valid" (click)="onSumbit()"
        *ngIf="authService.isEndpointStatus('PUT.Updateing.UpdateDevice')">Kaydet</button>
</div>